import * as mns from '../../mutation-types';

export default {
    state () {
        return {
            moneyLoss: {
                isChecked: false,
                value: ''
            },
            cardReissue: {
                isChecked: false,
                value: ''
            },
            documentsRestoration: {
                isChecked: false,
                value: ''
            },
            keysReplacement: {
                isChecked: false,
                value: ''
            },
            phonePurchase: {
                isChecked: false,
                value: ''
            },
            acquisitionEquipment: {
                isChecked: false,
                value: ''
            },
            involuntaryLoanProcessing: {
                isChecked: false,
                value: ''
            },
            leavingLife: {
                isChecked: false,
                value: ''
            },
            firstDisabilityGroup: {
                isChecked: false,
                value: ''
            },
            secondDisabilityGroup: {
                isChecked: false,
                value: ''
            },
            temporaryDisability: {
                isChecked: false,
                value: ''
            },
            injury: {
                isChecked: false,
                value: ''
            },
            hospitalization: {
                isChecked: false,
                value: ''
            },
            other: {
                isChecked: false,
                value: ''
            },
        }
    },
    getters: {
        moneyLoss(state) {
            return state.moneyLoss;
        },
        cardReissue(state) {
            return state.cardReissue;
        },
        documentsRestoration(state) {
            return state.documentsRestoration
        },
        keysReplacement(state) {
            return state.keysReplacement;
        },
        phonePurchase(state) {
            return state.phonePurchase;
        },
        acquisitionEquipment(state) {
            return state.acquisitionEquipment;
        },
        involuntaryLoanProcessing(state) {
            return state.involuntaryLoanProcessing;
        },
        leavingLife(state) {
            return state.leavingLife;
        },
        firstDisabilityGroup(state) {
            return state.firstDisabilityGroup;
        },
        secondDisabilityGroup(state) {
            return state.secondDisabilityGroup;
        },
        temporaryDisability(state) {
            return state.temporaryDisability;
        },
        injury(state) {
            return state.injury;
        },
        hospitalization(state) {
            return state.hospitalization;
        },
        other(state) {
            return state.other;
        },
    },
    mutations: {
        [mns.SET_MONEY_LOSS_IS_CHECKED](state, isChecked){
            state.moneyLoss.value = '';
            state.moneyLoss.isChecked = isChecked;
        },
        [mns.SET_MONEY_LOSS_VALUE](state, value){
            state.moneyLoss.value = state.moneyLoss.isChecked?value:'';
        },
        [mns.SET_CARD_REISSUE_IS_CHECKED](state, isChecked){
            state.cardReissue.value = '';
            state.cardReissue.isChecked = isChecked;
        },
        [mns.SET_CARD_REISSUE_VALUE](state, value){
            state.cardReissue.value = state.cardReissue.isChecked?value:'';
        },
        [mns.SET_DOCUMENTS_RESTORATION_IS_CHECKED](state, isChecked){
            state.documentsRestoration.value = '';
            state.documentsRestoration.isChecked = isChecked;
        },
        [mns.SET_DOCUMENTS_RESTORATION_VALUE](state, value){
            state.documentsRestoration.value = state.documentsRestoration.isChecked?value:'';
        },
        [mns.SET_KEYS_REPLACEMENT_IS_CHECKED](state, isChecked){
            state.keysReplacement.value = '';
            state.keysReplacement.isChecked = isChecked;
        },
        [mns.SET_KEYS_REPLACEMENT_VALUE](state, value){
            state.keysReplacement.value = state.keysReplacement.isChecked?value:'';
        },
        [mns.SET_PHONE_PURCHASE_IS_CHECKED](state, isChecked){
            state.phonePurchase.value = '';
            state.phonePurchase.isChecked = isChecked;
        },
        [mns.SET_PHONE_PURCHASE_VALUE](state, value){
            state.phonePurchase.value = state.phonePurchase.isChecked?value:'';
        },
        [mns.SET_ACQUISITION_EQUIPMENT_IS_CHECKED](state, isChecked){
            state.acquisitionEquipment.value = '';
            state.acquisitionEquipment.isChecked = isChecked;
        },
        [mns.SET_ACQUISITION_EQUIPMENT_VALUE](state, value){
            state.acquisitionEquipment.value = state.acquisitionEquipment.isChecked?value:'';
        },
        [mns.SET_INVOLUNTARY_LOAN_PROCESSING_IS_CHECKED](state, isChecked){
            state.involuntaryLoanProcessing.value = '';
            state.involuntaryLoanProcessing.isChecked = isChecked;
        },
        [mns.SET_INVOLUNTARY_LOAN_PROCESSING_VALUE](state, value){
            state.involuntaryLoanProcessing.value = state.involuntaryLoanProcessing.isChecked?value:'';
        },
        [mns.SET_LEAVING_LIFE_IS_CHECKED](state, isChecked){
            state.leavingLife.value = '';
            state.leavingLife.isChecked = isChecked;
        },
        [mns.SET_LEAVING_LIFE_VALUE](state, value){
            state.leavingLife.value = state.leavingLife.isChecked?value:'';
        },
        [mns.SET_FIRST_DISABILITY_GROUP_IS_CHECKED](state, isChecked){
            state.firstDisabilityGroup.value = '';
            state.firstDisabilityGroup.isChecked = isChecked;
        },
        [mns.SET_FIRST_DISABILITY_GROUP_VALUE](state, value){
            state.firstDisabilityGroup.value = state.firstDisabilityGroup.isChecked?value:'';
        },
        [mns.SET_SECOND_DISABILITY_GROUP_IS_CHECKED](state, isChecked){
            state.secondDisabilityGroup.value = '';
            state.secondDisabilityGroup.isChecked = isChecked;
        },
        [mns.SET_SECOND_DISABILITY_GROUP_VALUE](state, value){
            state.secondDisabilityGroup.value = state.secondDisabilityGroup.isChecked?value:'';
        },

        [mns.SET_TEMPORARY_DISABILITY_IS_CHECKED](state, isChecked){
            state.temporaryDisability.value = '';
            state.temporaryDisability.isChecked = isChecked;
        },
        [mns.SET_TEMPORARY_DISABILITY_VALUE](state, value){
            state.temporaryDisability.value = state.temporaryDisability.isChecked?value:'';
        },


        [mns.SET_INJURY_IS_CHECKED](state, isChecked){
            state.injury.value = '';
            state.injury.isChecked = isChecked;
        },
        [mns.SET_INJURY_VALUE](state, value){
            state.injury.value = state.injury.isChecked?value:'';
        },

        [mns.SET_HOSPITALIZATION_IS_CHECKED](state, isChecked){
            state.hospitalization.value = '';
            state.hospitalization.isChecked = isChecked;
        },
        [mns.SET_HOSPITALIZATION_VALUE](state, value){
            state.hospitalization.value = state.hospitalization.isChecked?value:'';
        },


        [mns.SET_OTHER_IS_CHECKED](state, isChecked){
            state.other.value = '';
            state.other.isChecked = isChecked;
        },
        [mns.SET_OTHER_VALUE](state, value){
            state.other.value = state.other.isChecked?value:'';
        },
    }
} // export.